import type MP4Box from 'mp4box';
import type { AddError } from '../../types/upload-video';
import { VALIDATIONS } from '../../types/upload-video';

const validateAspectRatio = (info: MP4Box.Mp4BoxInfo, addError: AddError): void => {
  if (info.videoTracks.length <= 0) {
    return;
  }
  const { height, width } = info.videoTracks[0].video;
  console.log(`Aspect ratio: ${width / height} width: ${width} height: ${height}`);

  const standardAspectRatio = 16 / 9;
  const wideAspectRatio = 32 / 9;
  const aspectRatio = width / height;
  if (aspectRatio !== standardAspectRatio && aspectRatio !== wideAspectRatio) {
    addError(VALIDATIONS.INVALID_DIMENSIONS);
  }
};

export default validateAspectRatio;
